module.exports = __webpack_public_path__ + "img/icon_map_36_off_011.ce925722.png";